import './scss/style.scss'
import "@coreui/coreui-pro/dist/js/coreui.bundle.min.js";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "bootstrap-icons/font/bootstrap-icons.css";
import Page404 from './views/pages/page404/Page404';
import { Home } from './views/home/Home';
import NavBar from './layout/NavBar';
import { ContactUS } from './views/contactus/ContactUs';
import { TermsAndConditions } from './views/termsandconditions/TermsAndConditions';
import { PolicyPrivacy } from './views/policyprivacy/PolicyPrivacy';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path='/' element={<NavBar ><Home /></NavBar>} />
        <Route path='/contactus' element={<NavBar ><ContactUS /></NavBar>} />
        <Route path='/termsandconditions' element={<NavBar ><TermsAndConditions /></NavBar>} />
        <Route path='/policyprivacy' element={<NavBar ><PolicyPrivacy /></NavBar>} />
        <Route path='*' element={<NavBar ><Page404 /></NavBar>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;